import SEGMENT_EVENTS from 'constants/segmentEvents';

function Ctrl($rootScope, $scope, utilsService, bookingHelpers, modalService, loggerService, favoritesService, tracking) {
  $scope.bookingUser = {};
  $scope.isFavorited = false;
  $scope.disableFavoriting = true;

  $scope.sanitizeNewlines = utilsService.sanitizeNewlines;

  $scope.confirmedUser = function(user) {
    return user.status === 'CONFIRMED';
  };

  $scope.$watch('booking', function(booking) {
    if (!booking) return;

    $scope.booking = booking;

    // Generate URLs
    $scope.directMapUrl = utilsService.getMapUrl(booking.venue.location.address, true);
    $scope.receiptPDF = bookingHelpers.downloadTicketLink(booking);

    $scope.statusText = bookingHelpers.getStatusText(booking);

    // Determine state of booking
    $scope.status = bookingHelpers.getStatus(booking);

    /* ----- Favoriting ----- */
    checkFavorited();
    $rootScope.$on('favoritesChange', checkFavorited);
  });

  $scope.contactSupport = function() {
    const text = ($scope.booking) ? `Booking ID: ${$scope.booking.id}` : '';

    modalService.contactSupport({
      message: `Hello Tablelist Concierge, I have a question about my booking. ${text}`
    });
  };

  $scope.cancelReservation = function() {
    const text = $scope.booking ? `Booking ID: ${$scope.booking.id}` : '';

    modalService.contactSupport({
      message: `Hello, I would like to cancel my reservation. ${text}`
    });
  };

  $scope.shareEvent = function(booking) {
    const url = (booking.event && booking.event.id) ? `/event/${booking.event.id}` : `/venue/${booking.venue.id}`;
    const name = (booking.event && booking.event.name) ? booking.event.name : booking.venue.name;

    modalService.shareLink({
      url: utilsService.createUrl(url),
      message: `Come join me at ${name}`
    });
  };

  $scope.bookNow = function(venue) {
    modalService.bookingWidget({
      venue: venue
    });
  };

  $scope.favoriteVenue = function(venue) {
    $scope.disableFavoriting = true;

    const func = ($scope.isFavorited) ? favoritesService.removeFavorite : favoritesService.addFavorite;
    const increment = ($scope.isFavorited) ? -1 : 1;

    func(favoritesService.TYPES.VENUE, venue.id)
      .then(() => {
        venue.favoriteCount += increment;

        const event = ($scope.isFavorited) ? SEGMENT_EVENTS.FavoritedVenue : SEGMENT_EVENTS.UnfavoritedVenue;

        tracking.trackEvent(event, {
          venueId: $scope.booking.venue.id,
          venueName: $scope.booking.venue.name
        });
      })
      .catch(err => {
        loggerService.error(err);
      })
      .finally(() => {
        $scope.disableFavoriting = false;
      });
  };

  function checkFavorited() {
    favoritesService.isFavorite(favoritesService.TYPES.VENUE, $scope.booking.venue.id)
      .then(function(favorited) {
        $scope.isFavorited = favorited;
        $scope.disableFavoriting = false;
      }).catch(function(err) {
        loggerService.error(err);
      });
  }
}

Ctrl.$inject = [
  '$rootScope',
  '$scope',
  'utilsService',
  'bookingHelpersService',
  'modalService',
  'loggerService',
  'favoritesService',
  'trackingService'
];

export default Ctrl;



// WEBPACK FOOTER //
// ./src/directives/bookingCard/controller.js